module.exports = __webpack_public_path__ + "images/help/searchbox@2x-05d6c1c8936fa3cf062bfc215847d6e5.png";